export const environment = {
  production: false,
  apiBaseUrl: 'https://api.prod.bikaji.distiz.com/api',
  apiversion: 1.0,
  reportApiBaseUrl: 'https://distizreportapi.bikaji.com/api',
  adminApiBaseUrl: 'https://distizadminapi.bikaji.com',
  blobBaseUrl: 'https://bikajisap.blob.core.windows.net/sap-prd/'
};